<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
    <input appInputDate formControlName="validFrom" [attr.max]="maxValidFrom">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meternumber' | translate }}</label>
    <select appSelect formControlName="meterNumber">
      <option [value]="null" disabled>{{ 'meteringpoint.meter.selectmeter' | translate }}</option>
      @for (item of meterList; track item.id) {
        <option [value]="item.id">{{ item | meterOptionLabel }}</option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.serialnumber' | translate }}</label>
    <input type="text" appInput formControlName="serialNumber">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.quadrant' | translate }}</label>
    <select appSelect formControlName="quadrant">
      <option [value]="null" disabled>{{ 'meteringpoint.meter.selectquadrant' | translate }}</option>
      @for (item of quadrant; track item.key) {
        <option [value]="item.key">
          {{ item.value | translate }}
        </option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.relativedeviation' | translate }}</label>
    <input appInput type="number" formControlName="relativeDeviation"
           append="%">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.absolutedeviation' | translate }}</label>
    <input appInput type="number" formControlName="absoluteDeviation"
           append="kWh">
  </app-input-group>
</form>
